var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-slider-banner-split-colors",class:[
    _vm.uppercase && 'heading-uppercase',
    !_vm.splitWords && 'heading-one-word' ]},[_c('span',{staticClass:"heading-black-part"},[_vm._v("\n    "+_vm._s(_vm.blackPartIfFullSentence || _vm.blackPart))]),_vm._v(" "),_c('span',{staticClass:"heading-red-part"},[_vm._v(_vm._s(_vm.redPart || _vm.redPartIfFullSentence))])])}
var staticRenderFns = []

export { render, staticRenderFns }